
import { VisualizacionTralletoria } from "../../dashboard/components"
import { MensajeAlertaDanger } from "../../components";
import { LayoutCrearDoc } from "../../layouts";
import { BuscadorXTermino } from "../../components/buscadores";
import { useRastrearOrdenProduccion } from "../../../hooks/cache";



export const RastrearOP = () => {

    const { data, termino, chageTermino } = useRastrearOrdenProduccion();


    return (

        <LayoutCrearDoc titulo='Rastrear Orden de Producción' add={false} pt={4} px={5}>
            <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="orden producción" playhol="o.p" />
            
            {(data?.items.length > 0)
            ?   <VisualizacionTralletoria op={data?.op} items={data?.items} />
            :   <MensajeAlertaDanger titulo='Por favor anote el numero de su orden de producción...' />
            }

        </LayoutCrearDoc>


    )
}
